import { DepositionFiles } from 'src/dataFactory/depositionFactory';
import { TableParams } from '../types';

export const depositionTypes = {
  SET_DEPOSITION: 'SET_DEPOSITION',
  GET_DEPOSITIONS: 'GET_DEPOSITIONS',
  GET_DEPOSITION_BY_ID: 'GET_DEPOSITION_BY_ID',
  CREATE_DEPOSITION: 'CREATE_DEPOSITION',
  UPDATE_DEPOSITION: 'UPDATE_DEPOSITION',
  DELETE_DEPOSITION: 'DELETE_DEPOSITION',
  APPROVE_DEPOSITION: 'APPROVE_DEPOSITION',
  REJECT_DEPOSITION: 'REJECT_DEPOSITION',
  LOCK_DEPOSITION: 'LOCK_DEPOSITION',
  COMPLETE_DEPOSITION: 'COMPLETE_DEPOSITION',
  APPROVE_FINAL_DEPOSITION: 'APPROVE_FINAL_DEPOSITION',
  GRANT_ACCESS_FINAL_DEPOSITION: 'GRANT_ACCESS_FINAL_DEPOSITION',
  GET_DEPOSITION_EXHIBIT_FILES: 'GET_DEPOSITION_EXHIBIT_FILES',
  GET_DEPOSITION_PRODUCTION_FILES: 'GET_DEPOSITION_PRODUCTION_FILES',
  GET_DEPOSITION_FINAL_FILES: 'GET_DEPOSITION_FINAL_FILES',
  SET_DEPOSITION_EXHIBIT: 'SET_DEPOSITION_EXHIBIT',
  SET_DEPOSITION_FINAL: 'SET_DEPOSITION_FINAL',
  SET_DEPOSITION_PRODUCTION: 'SET_DEPOSITION_PRODUCTION',
  GET_DEPOSITION_REQUESTER: 'GET_DEPOSITION_REQUESTER',
  GET_DEPOSITION_INVOLED_PARTIES: 'GET_DEPOSITION_INVOLED_PARTIES',
  // Files
  RESET_FILES: 'RESET_FILES',
  DELETE_FILE: 'DELETE_FILE',
  REJECT_FILE: 'REJECT_FILE',
  RENAME_FILE: 'RENAME_FILE',
  USE_EXHIBIT_IN_FINAL: 'USE_EXHIBIT_IN_FINAL',
};

export type GetDepositionDetailParam = { uri: string };
export type GetDepositionFileParam = {
  uri: string;
  params?: { [key: string]: string | number | string[] | undefined };
};

export type GetDepositionsParam = TableParams & { [key: string]: string };
export type FileIsFinalParam = { uri: string; useInFinal: boolean };
export type RenameFileParam = { uri: string; newName: string };
export type LockDepositionParam = { uri: string; action: string };
export type DeleteParam = { uri: string };

export type CreateDepositionPayload = {
  caseId: string;
  name: string;
  actualDate: string;
  openDate: string;
  caption: string;
  caseName: string;
  involvedParties: string[];
};

export type ApproveDepositionPayload = {
  uri: string;
  approveData: {
    involvedParties: string[];
  };
};
export type GrantAccessFinalPayload = {
  uri: string;
  updateAccessData: {
    involvedParties: { userId: string; canAccessFinalDeposition: boolean }[];
  };
};
export type RejectPayload = {
  reason: string;
  uri: string;
};
export type IDepositionState = Readonly<{
  depositionFiles: DepositionFiles;
}>;
